<template>
  <label class="radio-label">
    <input
      class="radio-input"
      :name="name"
      type="radio"
      @change="$emit('radioChange', value)"
    >
    <transition name="zoomIn">
      <span
        :class="{active: active}"
        class="radio-button"></span>
    </transition>
    <span
      :style="{'margin-left': offset + 'px'}"
      class="message">
      {{message}}
    </span>
  </label>
</template>

<script>
export default {
  name: 'AppRadioButtonSmall',
  props: {
    name: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    offset: {
      type: Number,
      default: 8,
    },
  },
};
</script>

<style lang="scss" scoped>
  .radio-label {
    display: flex;
    margin: 0;
  }
  .radio-input {
    display: none;
  }
  .radio-button {
    padding: 0 0 0 18px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      border: 1px solid #D6D8E9;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    &::after {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      transform: translateY(-50%);
      transition: transform .3s ease-out;
    }
    &.active::after {
      content: "";
      position: absolute;
      width: 8px;
      height: 8px;
      top: 50%;
      left: 50%;
      background: #2979FF;
      transform: translate(-50%, -50%);
      transition: .3s ease-out;
      transition-property: width, height, transform;
      border-radius: 50%;
    }
  }
</style>
